<template>
    <div>
        <select
            class="form-select"
            @change="yearChanged"
            :value="year"
            :disabled="disabled"
            @mousedown="assignDefaultYear"
        >
            <option :value="null" disabled></option>
            <option
                v-for="n in maxYear - minYear + 1"
                :key="n"
                :value="maxYear - n + 1"
                :selected="n === maxYear"
            >
                {{ `${maxYear - n + 1}年` }}
            </option>
        </select>
        <select
            class="form-select"
            @change="monthChanged"
            :value="month"
            :disabled="disabled"
        >
            <option :value="null" disabled></option>
            <option v-for="(m, i) in months" :key="i" :value="i">
                <!-- {{ m }} -->
                {{ `${i + 1}月` }}
            </option>
        </select>
    </div>
</template>

<script>
import _getYear from 'date-fns/getYear';
import _getMonth from 'date-fns/getMonth';
import _format from 'date-fns/format';
import _parse from 'date-fns/parse';

function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
}

function isDate(obj) {
    return Object.prototype.toString.call(obj) === '[object Date]';
}

export default {
    props: {
        value: { type: [Date, String] },
        minYear: { type: Number, default: _getYear(new Date()) - 100 },
        maxYear: { type: Number, default: _getYear(new Date()) },
        defaultYear: { type: Number, default: _getYear(new Date()) - 50 },
        format: { type: String, default: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx" },
        disabled: { type: Boolean, default: false }
    },
    data() {
        return {
            year: undefined,
            month: undefined
        };
    },
    created() {
        this.$watch(
            'value',
            function(v) {
                this.year = undefined;
                this.month = undefined;
                if (isString(v)) {
                    this.year = _getYear(_parse(v, this.format, new Date()));
                    this.month = _getMonth(_parse(v, this.format, new Date()));
                }
                if (isDate(v)) {
                    this.year = _getYear(v);
                    this.month = _getMonth(v);
                }
            },
            {
                immediate: true
            }
        );
    },
    computed: {
        months() {
            //prettier-ignore
            return [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];
        }
    },
    methods: {
        yearChanged(event) {
            this.year = event.target.value;
            this.changeDate();
        },
        monthChanged(event) {
            this.month = event.target.value;
            this.changeDate();
        },
        changeDate() {
            if (this.year && this.month && !this.disabled) {
                const date = new Date(this.year, this.month, 1);
                this.$emit('input', {
                    value: date,
                    valueFormatted: _format(date, this.format)
                });
            }
        },
        assignDefaultYear() {
            if (!this.year) {
                this.year = Math.max(
                    this.minYear,
                    Math.min(this.defaultYear, this.maxYear)
                );
            }
        }
    }
};
</script>
